const styles = (theme) => ({
  back: {
    marginLeft: -theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 2,
    fontSize: '1.3125rem',
    fontFamily: 'Calibre',
    color: theme.palette.text.dark,
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing.unit * 3,
      fontSize: '1.375rem',
    },
  },
  gutterTop: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: 0,
    },
  },
  chevronIcon: {
    width: '2.25rem',
    height: '2.25rem',
    color: theme.palette.primary.dark,
    verticalAlign: 'middle',
  },
});

export default styles;
